var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRegular(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_9550",
    "data-name": "Raggruppa 9550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 187.153,
    height: 48.393,
    viewBox: "0 0 187.153 48.393",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7916",
    "data-name": "Rettangolo 7916",
    width: 187.153,
    height: 48.393,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9549",
    "data-name": "Raggruppa 9549",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36922",
    "data-name": "Tracciato 36922",
    d: "M155.187,88.971a3.949,3.949,0,0,1,2.328.516,2.46,2.46,0,0,1,1.045,2.076,2.418,2.418,0,0,1-1.957,2.46l2.751,3.77h-1.627L155.2,94.182h-.238v3.611h-1.35V88.971Zm-.224,4.048h.423c.37,0,1.877-.04,1.877-1.442,0-1.243-1.177-1.361-1.838-1.361h-.463Z",
    transform: "translate(-85.999 -49.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36923",
    "data-name": "Tracciato 36923",
    d: "M189.881,93.187a4.589,4.589,0,1,1-4.589-4.577,4.475,4.475,0,0,1,4.589,4.577m-1.349,0a3.241,3.241,0,1,0-3.24,3.332,3.158,3.158,0,0,0,3.24-3.332",
    transform: "translate(-101.165 -49.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36924",
    "data-name": "Tracciato 36924",
    d: "M216.2,96.953l1.851-9.482,3.068,6.851,3.1-6.851,1.666,9.482H224.5l-.9-5.317-2.566,5.726L218.5,91.624l-.926,5.329Z",
    transform: "translate(-121.038 -48.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36925",
    "data-name": "Tracciato 36925",
    d: "M258.3,95.009h-3.77l-.965,2.13h-1.455L256.5,87.8l4.179,9.336h-1.455Zm-.542-1.269-1.309-2.989-1.362,2.989Z",
    transform: "translate(-141.143 -49.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36926",
    "data-name": "Tracciato 36926",
    d: "M155.015,30.166l.618-4.329h.177c2.342,1.723,5.566,3.446,9.054,3.446,3.755,0,5.963-2.3,5.963-5.079,0-2.517-1.236-4.285-6.8-6.624-6.448-2.651-8.657-5.433-8.657-9.587,0-4.461,3.578-7.992,9.673-7.992a16.329,16.329,0,0,1,8.568,2.339l-.574,4.2h-.176a13.426,13.426,0,0,0-7.951-2.827c-3.224,0-5.036,1.809-5.036,4.2,0,2.3,1.193,3.577,6.714,6.05,7.022,3.181,8.79,5.963,8.79,10.027,0,4.99-4.065,9.054-10.557,9.054a18.957,18.957,0,0,1-9.8-2.871",
    transform: "translate(-86.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36927",
    "data-name": "Tracciato 36927",
    d: "M233.043,15.478,245.365,33.1l-.134.176h-5.079L230.127,18.745l-4.815,5.522v9.01h-4.284V2.008h4.284V7.971c0,3.4-.088,7.2-.134,10.643h.089c2.163-2.517,4.416-5.213,6.537-7.641l7.772-8.965h5.037l.087.176Z",
    transform: "translate(-123.741 -1.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7913",
    "data-name": "Rettangolo 7913",
    width: 4.285,
    height: 31.27,
    transform: "translate(128.111 0.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36928",
    "data-name": "Tracciato 36928",
    d: "M325.068,2.008h4.286V29.392H343.4v3.886H325.068Z",
    transform: "translate(-181.987 -1.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36929",
    "data-name": "Tracciato 36929",
    d: "M383.561,2.008h4.282V29.392h14.045v3.886H383.561Z",
    transform: "translate(-214.734 -1.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36930",
    "data-name": "Tracciato 36930",
    d: "M0,1.976H10.145c5.094,0,9.966,2.37,9.966,8.937a6.42,6.42,0,0,1-3.263,5.765,7.3,7.3,0,0,1,4.871,7.332c0,5.494-4.558,9.249-10.458,9.249H0ZM9.966,14.758c2.994,0,4.692-1.118,4.692-3.844S12.6,7.072,9.966,7.072h-4.6v7.686Zm6.3,9.253c0-2.952-2.234-4.156-5.184-4.156H5.362v8.31h5.72c2.949,0,5.184-1.2,5.184-4.154",
    transform: "translate(0 -1.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36931",
    "data-name": "Tracciato 36931",
    d: "M65.009,1.976H75.154c5.094,0,9.966,2.37,9.966,8.937a6.42,6.42,0,0,1-3.263,5.765,7.3,7.3,0,0,1,4.871,7.332c0,5.494-4.558,9.249-10.458,9.249H65.009Zm9.966,12.782c2.994,0,4.692-1.118,4.692-3.844s-2.056-3.841-4.692-3.841h-4.6v7.686Zm6.3,9.253c0-2.952-2.234-4.156-5.184-4.156h-5.72v8.31h5.72c2.949,0,5.184-1.2,5.184-4.154",
    transform: "translate(-36.395 -1.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7914",
    "data-name": "Rettangolo 7914",
    width: 61.419,
    height: 1.031,
    transform: "translate(125.734 43.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7915",
    "data-name": "Rettangolo 7915",
    width: 61.419,
    height: 1.031,
    transform: "translate(0 43.058)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRegular);
export default __webpack_public_path__ + "static/media/logo-regular.fdd313af1f5f709b1918f45ce40f4cab.svg";
export { ForwardRef as ReactComponent };